function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoeqt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 534.3 525.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "11.34 488.78 35.97 488.78 35.97 478.56 11.34 478.56 11.34 467.97 39.33 467.97 39.33 457.74 0 457.74 0 509.98 39.7 509.98 39.7 499.75 11.34 499.75 11.34 488.78",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.3 488.79 216.93 488.79 216.93 478.56 192.3 478.56 192.3 467.97 220.29 467.97 220.29 457.74 180.96 457.74 180.96 509.98 220.66 509.98 220.66 499.75 192.3 499.75 192.3 488.79",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.42,487.26c0,4.18-1,7.31-2.99,9.4-1.99,2.09-4.75,3.14-8.28,3.14s-6.29-1.08-8.28-3.25c-1.99-2.17-2.99-5.39-2.99-9.66v-29.55h-11.49v29.85c0,7.71,2.01,13.5,6.04,17.39,4.04,3.88,9.56,5.82,16.57,5.82,3.48,0,6.64-.49,9.48-1.46,2.83-.97,5.25-2.44,7.23-4.4,1.99-1.96,3.52-4.41,4.59-7.35,1.07-2.93,1.6-6.39,1.6-10.37v-29.48h-11.49v29.92Z",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.01,484.19c-1.42-1.22-3.17-2.26-5.24-3.13-2.07-.87-4.42-1.65-7.07-2.35-2.25-.6-4.1-1.12-5.58-1.56-1.47-.45-2.63-.92-3.48-1.42-.85-.5-1.43-1.06-1.76-1.68-.33-.62-.49-1.36-.49-2.2v-.15c0-1.29.56-2.37,1.68-3.25,1.12-.87,2.8-1.3,5.04-1.3s4.48.46,6.72,1.38c2.24.92,4.52,2.18,6.87,3.77l5.97-8.66c-2.68-2.14-5.63-3.78-8.84-4.93-3.21-1.14-6.72-1.71-10.56-1.71-2.68,0-5.15.37-7.37,1.12-2.23.75-4.15,1.82-5.76,3.21-1.6,1.39-2.85,3.05-3.74,4.96-.89,1.92-1.33,4.07-1.33,6.46v.15c0,2.59.41,4.75,1.24,6.5.82,1.74,1.98,3.19,3.48,4.36,1.49,1.17,3.31,2.16,5.46,2.95,2.14.79,4.54,1.52,7.19,2.17,2.19.55,3.97,1.07,5.35,1.56,1.37.5,2.44,1,3.21,1.5.77.5,1.3,1.03,1.57,1.6.28.57.41,1.23.41,1.98v.15c0,1.54-.66,2.75-1.98,3.62-1.32.87-3.17,1.31-5.56,1.31-2.99,0-5.74-.57-8.25-1.72-2.51-1.14-4.96-2.68-7.35-4.63l-6.79,8.13c3.13,2.84,6.62,4.94,10.45,6.31,3.83,1.37,7.73,2.05,11.72,2.05,2.84,0,5.42-.36,7.75-1.08,2.33-.72,4.34-1.77,6.01-3.14,1.68-1.37,2.99-3.06,3.93-5.07.94-2.01,1.41-4.32,1.41-6.9v-.15c0-2.28-.36-4.25-1.09-5.89-.72-1.64-1.8-3.07-3.21-4.29Z",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.21 468.34 298.1 468.34 298.1 509.98 309.6 509.98 309.6 468.34 325.49 468.34 325.49 457.74 282.21 457.74 282.21 468.34",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379,485.46c2.07-2.66,3.1-6.1,3.1-10.33v-.15c0-5.42-1.73-9.65-5.19-12.68-3.46-3.04-8.29-4.55-14.51-4.55h-23.88v52.24h11.49v-16.72h9.03l11.2,16.72h13.43l-12.76-18.65c3.33-1.25,6.03-3.2,8.09-5.86Zm-8.54-9.74c0,2.24-.76,4.03-2.27,5.37-1.52,1.34-3.69,2.01-6.53,2.01h-11.64v-15h11.42c2.84,0,5.05.62,6.64,1.87,1.59,1.24,2.39,3.11,2.39,5.59v.15Z",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.68,457.55l-22.39,52.61h11.72l4.78-11.72h22.09l4.78,11.72h12.02l-22.39-52.61h-10.6Zm-1.79,30.75l6.94-16.94,6.94,16.94h-13.88Z",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.36,
    y: 457.74,
    width: 11.49,
    height: 52.24,
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "522.96 457.74 522.96 489.91 498.48 457.74 487.89 457.74 487.89 509.98 499.23 509.98 499.23 476.77 524.53 509.98 534.3 509.98 534.3 457.74 522.96 457.74",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.56,483.42c0-15.85-12.98-28.7-29-28.7s-29.01,12.85-29.01,28.7c0,7.24,2.71,13.85,7.18,18.9,1.02,1.23,2.17,2.33,3.44,3.3,4.71,3.82,10.66,6.21,17.16,6.48,2.51,6.72,10.33,11.06,17.35,13.07l9.46-10.69v-.44c-2.16.15-4.47.22-6.78.22-6.01,0-11.87-.61-14.91-2.39,14.18-1.89,25.11-13.9,25.11-28.45Zm-16.93,14.88c0,6.68-5.53,12.15-12.28,12.15s-12.27-5.47-12.27-12.15v-30.11c0-6.68,5.52-12.15,12.27-12.15s12.28,5.47,12.28,12.15v30.11Z",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.15,402.15c-110.87,0-201.08-90.2-201.08-201.07S156.28,0,267.15,0s201.08,90.2,201.08,201.08-90.2,201.07-201.08,201.07Zm0-397.06c-108.07,0-195.99,87.92-195.99,195.99s87.92,195.98,195.99,195.98,195.99-87.92,195.99-195.98S375.22,5.09,267.15,5.09Z",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.93,241.21v-85.83c0-19.05,15.59-34.63,34.64-34.63s34.64,15.58,34.64,34.63v56.01c-13.08,3.79-26.6,8-35.77,24.21-5.64,9.97-6.16,25.43-2.4,40.05-17.41-1.78-31.11-16.6-31.11-34.46m41.81,33.88c-2.69-6.32-6.1-25.9,1.02-38.14,6.2-10.65,17.75-16.32,26.44-19.5v23.76c0,16.59-11.83,30.55-27.47,33.88m4.41,4.79c39.99-5.37,70.83-39.63,70.83-81.09,0-45.2-36.64-81.83-81.83-81.83s-81.83,36.64-81.83,81.83c0,20.63,7.64,39.48,20.24,53.88,2.89,3.5,6.13,6.64,9.71,9.41,13.29,10.9,30.07,17.7,48.41,18.47,7.08,19.15,29.16,31.52,48.95,37.26l26.69-30.48v-1.26c-6.09.42-12.61.63-19.13.63-16.96,0-33.47-1.75-42.06-6.81",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoeqt);
export default __webpack_public_path__ + "static/media/logoeqt.8601f1e9af694d92b8bd9a80a7e66835.svg";
export { ForwardRef as ReactComponent };